import * as actionTypes from './actionTypes';
import generateFilteredLeads, {addGradeColor} from 'src/helpers/generateFilteredLeads';
import {ReducerActionType} from 'src/interfaces';

const initialState = Object.freeze({
  leadsList: [] as any[],
  filteredLeads: [] as any[],
  selectedLead: null as any,
  notes: [] as any[],
  topInterests: {} as any,
  fetchingInterests: 0 as number,
  numLeads: {} as any,
  fetchingLeads: 0 as number,
  pageHasUpdate: false as boolean,
  fetchingLeadsUpdate: 0 as number,
  refreshLeads: false as boolean,
  assignmentOptions: [] as any[],
  leadsTotals: {} as any,
  currentPage: 0 as number,
});

export default (state = initialState, action: ReducerActionType) => {
  switch (action.type) {
    case actionTypes.SET_LEADS_LIST:
      return {
        ...state,
        leadsList: action.value.data,
        filteredLeads: generateFilteredLeads(action.value.data, action.value.leadHeatLevel),
        pageHasUpdate: false,
      };

    case actionTypes.FETCHING_INTERESTS:
      return {
        ...state,
        fetchingInterests: action.value ? state.fetchingInterests + 1 : state.fetchingInterests - 1,
      };

    case actionTypes.PAGE_HAS_UPDATE:
      let pageHasUpdate = false;
      const lastLead = state.leadsList[0] && state.leadsList[0].lastLeadDateTime;
      const lastUpdatedLead = action.value.data[0] && action.value.data[0].lastLeadDateTime;
      if ((action.value.page === state.currentPage) && (lastLead !== lastUpdatedLead)) {
        pageHasUpdate = true;
      }
      return {
        ...state,
        pageHasUpdate,
      };

    case actionTypes.REFRESH_LEADS:
      return {
        ...state,
        refreshLeads: state.fetchingLeads > 0 ? false : true,
      };

    case actionTypes.FETCH_LEADS:
      let fetchingLeads = state.fetchingLeads;
      let fetchingLeadsUpdate = state.fetchingLeadsUpdate;
      if (action.value.isUpdate) {
        fetchingLeadsUpdate = action.value.fetching ? fetchingLeadsUpdate + 1 : fetchingLeadsUpdate - 1;
      } else {
        fetchingLeads = action.value.fetching ? fetchingLeads + 1 : fetchingLeads - 1;
      }
      return {
        ...state,
        fetchingLeads,
        fetchingLeadsUpdate,
        refreshLeads: false,
      };

    case actionTypes.SET_NUM_LEADS:
      return {
        ...state,
        numLeads: Object.assign({}, state.numLeads, action.value),
      };

    case actionTypes.ASSIGN_LEAD:
      const updatedLeadList = state.leadsList.map(lead => {
        if (lead.helixCustomerID === action.value.helixCustomerID) {
          lead.assignedToSalesRepID = action.value.assignToUserID;
        }
        return lead;
      });
      return {
        ...state,
        leadsList: updatedLeadList,
        filteredLeads: generateFilteredLeads(updatedLeadList, action.value.leadHeatLevel),
      };

    case actionTypes.UPDATE_DEAL_STATUS:
      const dealList = state.leadsList.map(lead => {
        if (lead.helixCustomerID === action.value.helixCustomerID) {
          lead.dealStatus = action.value.dealStatus;
        }
        return lead;
      });
      return {
        ...state,
        leadsList: dealList,
        filteredLeads: generateFilteredLeads(dealList, action.value.leadHeatLevel),
      };

    case actionTypes.ADD_TOP_INTEREST:
      return {
        ...state,
        topInterests: Object.assign({}, state.topInterests, action.value),
        fetchingInterests: state.fetchingInterests - 1,
      };

    // case NEXT_PAGE:
    //   let nextPage = state.currentPage;
    //   if (state.numLeads[state.currentLead] && (((nextPage + 1) * 20) < state.numLeads[state.currentLead])) {
    //     nextPage += 1;
    //   }
    //   return {
    //     ...state,
    //     currentPage: nextPage,
    //   };

    // case PREV_PAGE:
    //   let prevPage = state.currentPage;
    //   if (prevPage > 0) {
    //     prevPage -= 1;
    //   }
    //   return {
    //     ...state,
    //     currentPage: prevPage,
    //   };

    case actionTypes.SELECT_LEAD:
      return {
        ...state,
        selectedLead: {
          ...action.value,
          customer: {
            ...action.value.customer,
            customerInfo: addGradeColor(action.value.customer.customerInfo)
          }
        },
      };

    case actionTypes.SET_NOTES:
      return {
        ...state,
        notes: action.value,
      };

    case actionTypes.ADD_NOTE:
      return {
        ...state,
        notes: [action.value].concat(state.notes),
      };

    case actionTypes.UPDATE_SELECTED_LEAD:
      return {
        ...state,
        selectedLead: action.value ? addGradeColor({
          ...state.selectedLead,
          ...action.value,
        }) : null,
      };

    case actionTypes.UPDATE_LEADS_TOTALS:
      return {
        ...state,
        leadsTotals: action.value || {},
      };

    case actionTypes.RESET_STATE:
      return initialState;

    case actionTypes.SET_ASSIGNMENT_OPTIONS:
      return {
        ...state,
        assignmentOptions: action.value,
      };
    default:
      return state;
  }
};
